import { useNavigate } from 'react-router';

import { ScenarioRoutePaths } from '@app-velocity/modules/scenarios';

import { SelectFlowContext } from '../context/SelectFlowContext';
import { SelectFlow } from '..';

export const SelectFlowGuest = () => {
  const navigate = useNavigate();

  const configureGuestFlow = (nodeId: string) => {
    navigate(ScenarioRoutePaths.configureNewChallengeAsAGuest(nodeId));
  };

  return (
    <SelectFlowContext.Provider
      value={{
        mode: 'guest',
        configureFlow: configureGuestFlow,
      }}
    >
      <SelectFlow />
    </SelectFlowContext.Provider>
  );
};
